<template>
  <v-container fluid class="footer">
    <v-footer height="auto">
      <v-layout>
        <v-flex>
          <v-card id="card_footer" dark flat tile class="py-3 px-3">
            <v-card-text>
              <v-layout align-center justify-center row fill-height>
                <v-flex xs1>
                    <a href="https://fitetclimb.iliceimondovi.edu.it/files/Informativa.pdf" target="_blank">Privacy</a>
                </v-flex>
                <v-flex xs1>
                    <a href="http://www.iliceimondovi.edu.it/index.php/note-legali.html" target="_blank">Note Legali</a>
                </v-flex>
                <v-flex xs1>
                    <a href="http://www.iliceimondovi.edu.it/index.php/accessibilita.html" target="_blank">Accessibilità</a>
                </v-flex>
                <v-flex xs1>
                    <a href="http://www.iliceimondovi.edu.it/index.php/contattiliceo-2.html" target="_blank">Contatti</a>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-footer>
  </v-container>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>
<style scoped>
    a{
        text-decoration: none;
        color: #65dcdf ;
    }

    a:hover{
         text-decoration: underline;
    }

    #card_footer{
        background-color: #00264d;
    }

    .footer{
        padding-left: 0;
        padding-right: 0;
        padding-bottom: 0;
    }
</style>